module.exports = __webpack_public_path__ + "img/block-yellow.4ee9dc6d.webp";